// extracted by mini-css-extract-plugin
export var badgeImage = "styles-module__badgeImage___Sp1Jh";
export var badgeStarContainer = "styles-module__badgeStarContainer___lUDuZ";
export var container = "styles-module__container___TLxbc";
export var containerBgImage = "styles-module__containerBgImage___zcOu7";
export var hoverAnimation = "styles-module__hoverAnimation___Tk3wR";
export var innerContainer = "styles-module__innerContainer___wJAXp";
export var picture = "styles-module__picture___BmG7R";
export var rating = "styles-module__rating___fFw5G";
export var starsImage = "styles-module__starsImage___elslI";
export var stores = "styles-module__stores___xd56v";
export var titleTop = "styles-module__titleTop___ktEnw";
export var trademark = "styles-module__trademark___GHWcN";